module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_1_5.04d8a137.png";